var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoToolbarMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_1827_7488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 0C4.03 0 0 4.03 0 9C0 13.97 4.03 18 9 18C13.97 18 18 13.97 18 9C17.99 4.03 13.97 0 9 0ZM9.75 16.46V15C9.75 14.59 9.41 14.25 9 14.25C8.59 14.25 8.25 14.59 8.25 15V16.46C4.7 16.1 1.9 13.29 1.54 9.75H3C3.41 9.75 3.75 9.41 3.75 9C3.75 8.59 3.41 8.25 3 8.25H1.54C1.9 4.7 4.71 1.9 8.25 1.54V3C8.25 3.41 8.59 3.75 9 3.75C9.41 3.75 9.75 3.41 9.75 3V1.54C13.3 1.9 16.1 4.71 16.46 8.25H15C14.59 8.25 14.25 8.59 14.25 9C14.25 9.41 14.59 9.75 15 9.75H16.46C16.1 13.3 13.29 16.1 9.75 16.46ZM12 9C12 9.41 11.66 9.75 11.25 9.75H9.75V11.25C9.75 11.66 9.41 12 9 12C8.59 12 8.25 11.66 8.25 11.25V9.75H6.75C6.34 9.75 6 9.41 6 9C6 8.59 6.34 8.25 6.75 8.25H8.25V6.75C8.25 6.34 8.59 6 9 6C9.41 6 9.75 6.34 9.75 6.75V8.25H11.25C11.66 8.25 12 8.59 12 9Z",
    fill: "#767676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1827_7488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoToolbarMove);
export default __webpack_public_path__ + "static/media/ico-toolbar-move.b047624725f9340cff84262172372445.svg";
export { ForwardRef as ReactComponent };